import React from 'react';
import { verticals } from '../data/verticals';
import { verticalIcons, verticalHeroImage } from '../data/media';
import Bookshelf from '../components/Bookshelf';

const Groups: React.FC = () => {
  return (
    <>

      {/* OUR ECOSYSTEM — bookshelf, moved here from the Home page */}
      <section style={{ padding: '150px 0', background: '#fff' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 44 }}>
            <h2 className="section-title">United by Purpose. Driven by Care.</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              Our 9+ specialised verticals, shelved together. Hover a spine to open it.
            </p>
          </div>
          <Bookshelf items={verticals} images={verticalHeroImage} icons={verticalIcons} />
        </div>
      </section>

    </>
  );
};

export default Groups;